import { useState, cloneElement } from "react";
import { api, apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setNw(""); setCf(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 8) return toast.error("New password must be at least 8 characters");
    if (nw !== cf) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed successfully");
      reset();
      setOpen(false);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {cloneElement(trigger, { onClick: () => setOpen(true) })}
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) reset(); }}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Change password</DialogTitle>
          <DialogDescription>Update your account password. You&apos;ll stay signed in on this device.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label htmlFor="cp-cur">Current password</Label>
            <Input id="cp-cur" type="password" data-testid="cp-current" value={cur} onChange={(e) => setCur(e.target.value)} required className="mt-1" autoComplete="current-password" />
          </div>
          <div>
            <Label htmlFor="cp-new">New password</Label>
            <Input id="cp-new" type="password" data-testid="cp-new" value={nw} onChange={(e) => setNw(e.target.value)} required className="mt-1" autoComplete="new-password" placeholder="At least 8 characters" />
          </div>
          <div>
            <Label htmlFor="cp-cf">Confirm new password</Label>
            <Input id="cp-cf" type="password" data-testid="cp-confirm" value={cf} onChange={(e) => setCf(e.target.value)} required className="mt-1" autoComplete="new-password" />
          </div>
          <DialogFooter>
            <Button type="submit" data-testid="cp-submit" disabled={busy} className="w-full">{busy ? "Saving…" : "Change password"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
      </Dialog>
    </>
  );
}
